/* eslint-disable block-scoped-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-nested-ternary */
import {
  Avatar,
  Button,
  Checkbox,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Stack,
  Switch,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  alpha,
} from '@mui/material';
import { capitalize, isString } from 'lodash';
import IconifyLegacy from '../iconify/iconify-legacy';
import { LabelColor } from '../label';
import LabelLegacy from '../label/labelLegacy';
import { HeaderProps } from './TableRox';
import MenuPopover from '../menu-popover/MenuPopover';
import { useState } from 'react';
import { IconButtonAnimate } from '../animate';
import ScrollbarLegacy from '../scrollbar/scrollbarlegacy';
import { tableStatusColor } from 'src/utils/getColorByStatus';
import { tableMasks } from 'src/utils/tableMasks';

import { money } from 'src/utils/utils';

type Props = {
  row: any;
  header: Array<HeaderProps>;
  selectType: string;
  selectKey: string;
  selected: string[];
  onSelectRow: (id: string) => void;
  onClickKey: string;
  onClickFunction?: (id: string) => void;
  disableOnSelect?: boolean;
  avatarKey?: string | undefined;
  avatarType?: 'label' | 'icon' | 'default';
  actionKey: string;
  isAdvancedReport?: boolean;
  showTime?: boolean;
};

export default function TableRowRox({
  row,
  header,
  selectType,
  selected,
  selectKey,
  onSelectRow,
  onClickKey,
  onClickFunction,
  disableOnSelect,
  avatarKey,
  avatarType,
  actionKey,
  isAdvancedReport = false,
  showTime = false,
}: Props) {
  const [open, setOpen] = useState<HTMLElement | null>(null);
  const menuPopOverItemHeight: number = 32;

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <TableRow
      hover={
        !!onClickFunction ||
        (!!onClickFunction && disableOnSelect && !selected.includes(row[selectKey]))
      }
      sx={{
        '&:hover': {
          cursor:
            !!onClickFunction ||
            (!!onClickFunction && disableOnSelect && !selected.includes(row[selectKey]))
              ? 'pointer'
              : undefined,
        },
      }}
      onClick={() =>
        (!!onClickFunction ||
          (disableOnSelect && selected.includes(row[selectKey]) && !!onClickFunction)) &&
        onClickFunction(row[onClickKey])
      }
    >
      {selectType !== 'none' && (
        <TableCell
          padding="checkbox"
          onClick={(e) => {
            e.stopPropagation();
            onSelectRow(row[selectKey]);
          }}
        >
          <Checkbox
            checked={selected.includes(row[selectKey])}
            inputProps={{ 'aria-label': `Selecionar ${row.name || row[selectKey]}` }}
          />
        </TableCell>
      )}
      {header.map((head, idx) => {
        const headIdArray = head.id.split(' ')[0].split('.');
        if (head.subId) {
          const headSubIdArray = head.subId.split('.');
          var dataRowSub = row;
          headSubIdArray.forEach((id) => {
            dataRowSub = dataRowSub[id] ? dataRowSub[id] : '';
          });
        }
        var dataRow = row;
        headIdArray.forEach((id) => {
          dataRow = dataRow[id] ? dataRow[id] : '-';
        });
        return (
          <TableCell key={idx}>
            {isAdvancedReport && head.id === 'downloadLink' ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => window.open(dataRow, '_blank')}
                sx={{ color: 'white' }}
                disabled={dataRow === '' || dataRow === '-'}
              >
                Download
              </Button>
            ) : isAdvancedReport && head.id === 'status' ? (
              <LabelLegacy
                color={dataRow === 'pending' ? 'warning' : dataRow === 'done' ? 'success' : 'error'}
              >
                {dataRow === 'pending' ? 'Pendente' : dataRow === 'done' ? 'Concluído' : 'Erro'}
              </LabelLegacy>
            ) : (head.type && head.type) === 'label' ? (
              <LabelLegacy color={(tableStatusColor(dataRow).color as LabelColor) || `primary`}>
                {tableStatusColor(dataRow).translate}
              </LabelLegacy>
            ) : head.renderCell ? (
              head.renderCell(dataRow, row)
            ) : head.actions ? (
              <>
                <IconButtonAnimate
                  color={open ? 'primary' : 'default'}
                  onClick={handleOpen}
                  sx={{
                    width: 40,
                    height: 40,
                    ...(open && {
                      bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
                    }),
                  }}
                >
                  <IconifyLegacy icon="mdi:dots-vertical" />
                </IconButtonAnimate>
                <MenuPopover
                  open={Boolean(open)}
                  anchorEl={open}
                  onClose={handleClose}
                  sx={{
                    mt: 1.5,
                    ml: 0.75,
                    width: 320,
                    '& .MuiMenuItem-root': {
                      px: 1.5,
                      height: menuPopOverItemHeight,
                      borderRadius: 0.75,
                    },
                  }}
                >
                  <ScrollbarLegacy sx={{ height: menuPopOverItemHeight * head.actions.length }}>
                    {head.actions.map((action) => (
                      <MenuItem key={action.label} onClick={() => action.callback(row[selectKey])}>
                        <ListItemIcon>
                          <IconifyLegacy icon={action.icon} />
                        </ListItemIcon>
                        <ListItemText
                          primaryTypographyProps={{
                            typography: 'subtitle2',
                            mb: 0.25,
                          }}
                          secondaryTypographyProps={{ typography: 'caption' }}
                          primary={action.label}
                        />
                      </MenuItem>
                    ))}
                  </ScrollbarLegacy>
                </MenuPopover>
              </>
            ) : head.action && head.action.type === 'switch' ? (
              <Switch
                checked={row[actionKey]}
                onChange={(_, v) => head.action?.callback(row[selectKey], v)}
              />
            ) : (
              <Stack direction="row" spacing={2} alignItems="center">
                {avatarKey && (idx === 0 || head.avatar) && (
                  <>
                    {avatarType === 'default' ? (
                      <Avatar>
                        <img
                          style={{ objectFit: 'cover' }}
                          loading="lazy"
                          alt="row_avatar"
                          src={
                            Array.isArray(row[avatarKey]) && row[avatarKey].length > 0
                              ? row[avatarKey][0]?.urlName || row[avatarKey][0]
                              : isString(row[avatarKey])
                                ? row[avatarKey]
                                : ''
                          }
                        />
                      </Avatar>
                    ) : (
                      <LabelLegacy
                        color={
                          disableOnSelect && selected.includes(row[selectKey])
                            ? 'default'
                            : 'primary'
                        }
                      >
                        {capitalize(row[avatarKey][0])}
                      </LabelLegacy>
                    )}
                  </>
                )}
                {avatarType === 'icon' && (
                  <IconifyLegacy
                    width={24}
                    height={24}
                    color="secondary.main"
                    icon={head?.icon || ''}
                  />
                )}
                <Stack>
                  <Typography
                    sx={{
                      textDecoration:
                        disableOnSelect && selected.includes(row[selectKey])
                          ? 'line-through'
                          : undefined,
                      color: (theme) =>
                        disableOnSelect && selected.includes(row[selectKey])
                          ? theme.palette.text.secondary
                          : undefined,
                    }}
                    variant="subtitle2"
                    fontWeight={idx === 0 ? '600' : '500'}
                  >
                    {head.type && head.type === 'translate' ? (
                      tableStatusColor(dataRow).translate
                    ) : head.type && head.type === 'date' && dataRow !== '-' ? (
                      new Intl.DateTimeFormat('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        ...(showTime && {
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false,
                          timeZone: 'America/Sao_Paulo',
                        }),
                      }).format(new Date(dataRow))
                    ) : head.type && head.type === 'dateOnly' && dataRow !== '-' ? (
                      new Intl.DateTimeFormat('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        timeZone: 'America/Sao_Paulo'
                      }).format(new Date(dataRow))
                    ) : head.type && head.type === 'label' ? (
                      <LabelLegacy color={tableStatusColor(dataRow).color as LabelColor}>
                        {tableStatusColor(dataRow).translate}
                      </LabelLegacy>
                    ) : head.type && head.type === 'labelToShow' ? (
                      <LabelLegacy color={dataRow !== '-' ? 'success' : 'error'}>
                        {dataRow !== '-' ? 'Ativo' : 'Inativo'}
                      </LabelLegacy>
                    ) : head.type && head.type === 'screen' ? (
                      <LabelLegacy color={dataRow === '#home' ? 'secondary' : 'primary'}>
                        {dataRow === undefined || dataRow === null ? '-' : dataRow}
                      </LabelLegacy>
                    ) : head.type && head.type === 'money' ? (
                      <LabelLegacy color={tableStatusColor(row.type).color as LabelColor}>
                        {row.value === undefined || row.value === null ? '-' : money(row.value)}
                      </LabelLegacy>
                    ) : head.type && head.type === 'isViva' ? (
                      <LabelLegacy color={tableStatusColor(dataRow).color as LabelColor}>
                        {dataRow === true ? tableStatusColor(dataRow).translate : 'Não Viva'}
                      </LabelLegacy>
                    ) : head.type && head.type === 'tier' ? (
                      dataRow.length > 0 ? (
                        <Stack spacing={1}>
                          {dataRow?.map((tier: any) => (
                            <LabelLegacy
                              variant="filled"
                              color={tableStatusColor(tier).color as LabelColor}
                            >
                              {tableStatusColor(tier).translate}
                            </LabelLegacy>
                          ))}
                        </Stack>
                      ) : (
                        <LabelLegacy color="info">Todos</LabelLegacy>
                      )
                    ) : head.type && head.type === 'coupon-type' ? (
                      <LabelLegacy
                        color={
                          dataRow === 'simple'
                            ? 'secondary'
                            : dataRow === 'code'
                              ? 'info'
                              : 'primary'
                        }
                      >
                        {dataRow === 'simple'
                          ? 'Simples'
                          : dataRow === 'code'
                            ? 'Código'
                            : dataRow === 'giftback'
                              ? 'Giftback'
                              : dataRow === 'uniqueCode'
                              ? 'Código Único'
                              : ''}
                      </LabelLegacy>
                    ) : head.type && head.type === 'mission-type' ? (
                      dataRow === 'check-in' ? (
                        'Check-in'
                      ) : dataRow === 'quiz' ? (
                        'Quiz'
                      ) : dataRow === 'scan-count' ? (
                        'Scan de nota'
                      ) : dataRow === 'instant' ? (
                        'Instantânea'
                      ) : (
                        ''
                      )
                    ) : head.type && head.type === 'product-type' ? (
                      <LabelLegacy color={dataRow === 'Simples' ? 'warning' : 'info'}>
                        {dataRow}
                      </LabelLegacy>
                    ) : head.type && head.type === 'uniqueRedemption' ? (
                      <LabelLegacy color={dataRow !== '-' ? 'success' : 'error'}>
                        {dataRow !== '-' ? 'Sim' : 'Não'}
                      </LabelLegacy>
                    ) : head.type && head.type === 'substr' ? (
                      dataRow.length > 50 ? (
                        <Tooltip title={dataRow}>{`${dataRow.substr(0, 55)}...` as any}</Tooltip>
                      ) : (
                        dataRow
                      )
                    ) : head.mask ? (
                      tableMasks(head.mask, dataRow)
                    ) : (
                      dataRow
                    )}
                  </Typography>
                  {(dataRowSub || dataRowSub === '') && (
                    <Typography
                      sx={{
                        textDecoration:
                          disableOnSelect && selected.includes(row[selectKey])
                            ? 'line-through'
                            : undefined,
                      }}
                      variant="body2"
                      color="text.secondary"
                    >
                      {dataRowSub}
                    </Typography>
                  )}
                </Stack>
              </Stack>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
